import { Injectable } from '@angular/core';
import 'rxjs/Rx';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from "app/globals";
import { Observable } from 'rxjs';


@Injectable()
export class AdminService {

    url: string = `${this._Globals.serviceUrl}AdminService.svc/`;

    constructor(
        private httpClient: HttpClient,
        private _Globals: Globals) { }

    public DeleteQuestion(questionId: number): Observable<any> {
        const url = `${this.url}DeleteQuestion`;
        
        const options: any = {
            body: {
                "questionId": questionId
            }
        };

        return this.httpClient.request('delete', url, options);
    }

    public DeleteSectionChoice(choiceId: number): Observable<any> {

        let url = `${this.url}DeleteSectionChoice`;

        let options: any = {
            body: {
                'choiceId': choiceId
            }
        };

        return this.httpClient.request('delete', url, options);

    }

    public getAnnouncement(announcementId: any): Observable<any> {

        let url = `${this.url}GetAnnouncement?announcementId=${announcementId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getAssessment(assessmentId: number): Observable<any> {

        let url = `${this.url}GetAssessment?assessmentId=${assessmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getAssessmentReport(clientId: number, assignmentId: number, userType: number): Observable<any> {

        let url = `${this.url}GetAssessmentReport?clientId=${clientId}&assignmentId=${assignmentId}&userType=${userType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());
        
        return this.httpClient.get(url, { headers: headers });
    }

    public getAssessments(): Observable<any> {

        let url = `${this.url}GetAssessments`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    public getChoiceSet(choiceSetId: number): Observable<any> {

        let url = `${this.url}GetChoiceSet?choiceSetId=${choiceSetId}`;

        return this.httpClient.get(url);
    }

    public getChoiceSets(sectionType: number): Observable<any> {

        let url = `${this.url}GetChoiceSets?sectionType=${sectionType}`;

        return this.httpClient.get(url);

    }

    public getGlobalRaterTypes(): Observable<any> {
        let url = `${this.url}GetGlobalRaterTypes`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getLanguages() {
        let url = `${this.url}GetLanguages`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getNiches() {

        let url = `${this.url}GetNiches`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    //{"email":"mary.smith@email.com","password":"123456"}
    public postAuthenticateUser(email: string, pass: string): Observable<any> {
        let url = `${this.url}AuthenticateUser`;
        // let url = `http://localhost:54541/AdminService.svc/AuthenticateUser`;

        let body: any = {
            "email": email,
            "password": pass,
        };

        body = JSON.stringify(body);
        console.log('body postAuthenticateUser: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getPageTypes(): Observable<any> {
        let url = `${this.url}GetPageTypes`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getQuestion(questionId: number): Observable<any> {

        let url = `${this.url}GetQuestion?questionId=${questionId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });

    }

    public getQuestions(type: number): Observable<any> {
        let url = `${this.url}GetQuestions?type=${type}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });

    }

    public getSectionChoice(choiceId: number): Observable<any> {

        let url = `${this.url}GetSectionChoice?choiceId=${choiceId}`;

        return this.httpClient.get(url);

    }

    public getSectionChoices(sectionId: number): Observable<any> {
        let language = 'en';
        let url = `${this.url}GetSectionChoices?sectionId=${sectionId}&language=${language}`;

        return this.httpClient.get(url);

    }

    public getTemplateFields(): Observable<any> {

        let url = `${this.url}GetTemplateFields?templateType=2`;

        return this.httpClient.get(url);

    }

    public getTemplatePurposes(): Observable<any> {
        let url = `${this.url}GetTemplatePurposes`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    public getTemplatesByType(): Observable<any> {

        var templateType = 1;

        let url = `${this.url}GetTemplatesByType?templateType=${templateType}`;

        return this.httpClient.get(url);

    }

    public getUserTypes(): Observable<any> {
        let url = `${this.url}GetUserTypes`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getUserTypesByTemplateType(creatorType:number): Observable<any> {

        let url = `${this.url}GetUserTypesByTemplateType?templateType=2&creatorType=${creatorType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"announcementId":[ANNOUNCEMENT ID]}
    public postDeleteAnnouncement(announcementId: number): Observable<any> {
        let url = `${this.url}DeleteAnnouncement`;

        let body: any = {
            "announcementId": announcementId
        };

        body = JSON.stringify(body);
        console.log('body deleteAnnouncement: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"raterTypeId":[RATER TYPE ID]}
    public postDeleteRaterType(raterTypeId: number): Observable<any> {
        let url = `${this.url}DeleteRaterType`;

        let body: any = {
            "raterTypeId": raterTypeId
        };

        body = JSON.stringify(body);
        console.log('body Post Save Assessments: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveAnnouncement(id: number, text: string, expiresOn:string, isActive:boolean): Observable<any> {
        let url = `${this.url}SaveAnnouncement`;

        let body: any = {
            "announcement":
            {
                "Id": id,
                "Text": text,
                "CreatedBy": this._Globals.getUserId(),
                "ExpiresOn": expiresOn,
                "IsActive": isActive
            }
        };

        body = JSON.stringify(body);

        console.log('body PostSaveAnnouncement: ' + body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveAssessments(assessmentDto: SaveAssessmentsDto): Observable<any> {
        let url = `${this.url}SaveAssessment`;

        let assessment: any = {
            "Id": parseInt(assessmentDto.id),
            "Name": assessmentDto.name,
            "Niche": 1,
            "Price": assessmentDto.price,
            "MajorVersion": parseInt(assessmentDto.majorVersion),
            "MinorVersion": parseInt(assessmentDto.minorVersion),
            "Sections": assessmentDto.sections,
            "ReportTemplates": assessmentDto.reportTemplates,
            "EmailTemplates": assessmentDto.emailTemplates,
            "Is360": assessmentDto.is360
        };

        let postSaveAssessments: any = {
            "assessment": assessment
        }

        let body = JSON.stringify(postSaveAssessments);
        console.log('body Post Save Assessments: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveChoiceSet(choiceSetDto: ChoiceSetDto): Observable<any> {
        let url = `${this.url}SaveChoiceSet`;

        let saveChoiceSet: any = {
            "input": {
                "ChoiceSetId": choiceSetDto.ChoiceSetId,
                "Name": choiceSetDto.Name,
                "Choices": choiceSetDto.Choices,
                "SectionType": choiceSetDto.SectionType
            }
        };
        let body = JSON.stringify(saveChoiceSet);
        console.log('body PostSaveChoiceSet: ' + body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveQuestion(questionDto: QuestionDto): Observable<any> {
        let url = `${this.url}SaveQuestion`;

        let postSaveQuestion: any = {
            "question": {
                "Id": questionDto.Id,
                "Type": questionDto.Type,
                "Level": questionDto.Levels,
                "NegativelyKeyed": questionDto.NegativelyKeyed,
                "IsTestQuestion": questionDto.IsTestQuestion,
                "Localizations": questionDto.Localizations,
                "Choices": questionDto.Choices,
                "IsMandatory": questionDto.IsMandatory,
                "Category": questionDto.Category
            }
        };
        let body = JSON.stringify(postSaveQuestion);
        console.log('body postSaveQuestion: ' + body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveRaterType(raterType: RaterTypeDto): Observable<any> {
        let url = `${this.url}SaveRaterType`;

        let body: any = {
            "raterType": {
                "Id": raterType.Id,
                "Name": raterType.Name,
                "Min": raterType.Min,
                "IsGlobal": raterType.IsGlobal,
                "Owner": this._Globals.getUserId()
            }
        };

        body = JSON.stringify(body);
        console.log('body SaveRaterType: ', body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveSectionChoice(sectionChoice: SectionChoice): Observable<any> {
        let url = `${this.url}SaveSectionChoice`;

        let postSaveSectionChoice: any = {
            "input": {
                "ChoiceId": sectionChoice.ChoiceId,
                "SectionId": sectionChoice.SectionId,
                "Text": sectionChoice.Text,
                "Order": sectionChoice.Order,
                "PositivePoints": sectionChoice.PositivePoints,
                "NegativePoints": sectionChoice.NegativePoints,
                "Localizations": sectionChoice.Localizations
            }

        };
        let body = JSON.stringify(postSaveSectionChoice);
        console.log('body postSaveQuestion: ' + body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    public putChangeSectionChoiceOrder(input: IInput): Observable<any> {
        let url = `${this.url}ChangeSectionChoiceOrder`;

        let body: any = {
            "input": input
        };

        body = JSON.stringify(body);
        console.log('body: ' + body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.put(url, body, { headers: headers });
    }

    public getAssessmentsByNiche(niche: number): Observable<any> {
        let url = `${this.url}GetAssessmentsByNiche?niche=${niche}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    //{"templateId":[TEMPLATE ID]}
    public postDeleteEmailTemplate(templateId: number): Observable<any> {
        let url = `${this.url}DeleteEmailTemplate`;

        let body: any = {
            "templateId": templateId
        }

        body = JSON.stringify(body);
        console.log('deleteEmailTemplate body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postPurchaseProcess(purchase: AssessmentPurchaseDto): Observable<any> {
        let url = `${this.url}OJ2`;

        let body: any = {
            "ab2":
            {
                "LU0": purchase.CoachId,
                "LU7": purchase.TotalAmount,
                "LU5": purchase.AssignedId,
                "LU4": purchase.EncriptedCardId,
                "LU3": purchase.Details, 
            }
        }

        body = JSON.stringify(body);
        console.log('body postPurchaseProcess: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    } 

    public postSaveAssessmentAssignmentByAdmin(purchase: AdminAssessmentPurchaseDto[]): Observable<any> {
        let url = `${this.url}SaveAssessmentAssignmentByAdmin`;

        let body: any = {
            "input": purchase
        }

        body = JSON.stringify(body);
        console.log('body saveAssessmentAssignment: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getErrorLogEntries(): Observable<any> {
        let url = `${this.url}GetErrorLogEntries`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getQuestionCategories(): Observable<any> {
        let url = `${this.url}GetQuestionCategories`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"assignmentId":[ASSIGNMENT ID]}
    public postLockAssessment(assignmentId: number): Observable<any> {
        let url = `${this.url}LockAssessment`;

        let body: any = {
            "assignmentId": assignmentId
        }

        body = JSON.stringify(body);
        console.log('postLockAssessment body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getSecurityQuestions(): Observable<any> {
        let url = `${this.url}GetSecurityQuestions`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getUserSecurityQuestions(userId: any): Observable<any> {
        let url = `${this.url}GetUserSecurityQuestions?userId=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postValidateSecurityAnswers(userId:number, answers: any[]): Observable<any> {
        let url = `${this.url}ValidateSecurityAnswers`;

        let body: any = {
            "userId": userId,
            "answers": answers,
        }

        body = JSON.stringify(body);
        console.log('postValidateSecurityAnswers body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getUsers(): Observable<any> {
        let url = `${this.url}GetUsers`;
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postTokenSSO(token:string): Observable<any> {
        let url = `${this.url}TR4`;
        // let url = `http://localhost:54541/AdminService.svc/TR4`;

        let body: any = {
            "k9": token
        }

        body = JSON.stringify(body);
        console.log('body postTokenSSO: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminServices.svc/KN7
    public postDownloadReportAssessmentModlll(dateValue: string, dateText: string): Observable<any> {
        let url = `${this.url}KN7`;

        let body: any = {
            "zz2": this._Globals.getUserId(),
            "jh2": dateValue,
            "ds": dateText
        }

        body = JSON.stringify(body);
        console.log('postDownloadReportAssessmentModlll body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminService.svc/QA57
    public postAddNewAssessmentModlllStudent(encryptedData: string): Observable<any> {
        let url = `${this.url}QA57`;

        let body: any = {
            "xv3": encryptedData
        }

        body = JSON.stringify(body);
        console.log('postAddNewAssessmentModlllStudent body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }


    //AdminServices.svc/MW34
    public postEnableResultsModlll(dateValue: string): Observable<any> {
        let url = `${this.url}MW34`;

        let body: any = {
            'jb3': dateValue
        }

        body = JSON.stringify(body);
        console.log('postEnableResultsModlll body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminService.svc/UH98?hg={2020-04-21T00:00:00}
    public getAssessmentsModlllStudents(dateValue:string): Observable<any> {
        let url = `${this.url}UH98?hg=${dateValue}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //AdminService.svc/LW85
    public postCreateAssessmentMod3Group(encriptedData: string): Observable<any> {
        let url = `${this.url}LW85`;

        let body: any = {
            'vy8': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postCreateAssessmentMod3Group body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminService.svc/GQ23
    public postDeferStudents(encriptedData: string): Observable<any> {
        let url = `${this.url}GQ23`;

        let body: any = {
            'gp5': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postCreateAssessmentMod3Group body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //synk dminService.svc/RV7
    public postAssessmentsModIIISync(encriptedData: string): Observable<any> {
        let url = `${this.url}RV7`;

        let body: any = {
            'xk8': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postCreateAssessmentMod3Group body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //activate account prevent use default password
    public postPreventUseDefaultPassword(encriptedData: string): Observable<any> {
        let url = `${this.url}BT2`;

        let body: any = {
            'dw4': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postPreventUseDefaultPassword body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public PostGetStatisticsChartsData(year: number, assessmentId: number, interval: number): Observable<any> {
    let url = `${this.url}HE8`;

        let body: any = {
            "ht5": year,
            "ng9": assessmentId,
            "nr6": interval
        }

        body = JSON.stringify(body);
        console.log('PostGetStatisticsChartsData body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public PostGetStatisticsTodaysData(): Observable<any> {
        let url = `${this.url}PT6`;

        let body: any = { }

        body = JSON.stringify(body);
        console.log('PostGetStatisticsTodaysData body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    
    //activate account prevent use default password
    public postAdminResetPassword(encriptedData: string): Observable<any> {
        let url = `${this.url}XR34`;

        let body: any = {
            'cr2': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postAdminResetPassword body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getUserPersonalData(userId:number): Observable<any> {
        let url = `${this.url}SF28?ln2=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postUpdatePersonalData(encriptedData: string): Observable<any> {
        let url = `${this.url}DI52`;

        let body: any = {
            'wt8': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postUpdatePersonalData body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getAdminAnnouncements(): Observable<any> {
        let url = `${this.url}KV67`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postSendEmail(recipients: Array<string>, subject: string, body: string, cc: Array<string>): Observable<any> {
        const url = `${this.url}SendEmail`;

        let reqBody: any = {
            recipients,
            subject,
            body,
            cc
        };

        reqBody = JSON.stringify(reqBody);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, reqBody, { headers });
    }

    public postUpdateUserEmail(userId: number, newEmail: string): Observable<any> {
        const url = `${this.url}UpdateUserEmail`;

        let reqBody: any = {
            userId,
            newEmail
        };

        reqBody = JSON.stringify(reqBody);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, reqBody, { headers });
    }

    public getUserCoaches(userId: string): Observable<{result: {Result: number, Data: string}}> {
         let url = `${this.url}GetUserCoachesByUserId?userId=${userId}`;
        //let url = `http://localhost:54541/AdminService.svc/GetUserCoachesByUserId?userId=${userId}`;
    
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());
    
        return this.httpClient.get<{result: {Result: number, Data: string}}>(url, { headers: headers });
    }

    public getPagedUsers(
        pageNumber: number, 
        pageSize: number,
        firstName: string,
        lastName: string,
        email: string,
        userType: string): Observable<{result: {Result: number, Data: string}}> {
         let url = `${this.url}GetPagedUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        //let url = `http://localhost:54541/AdminService.svc/GetPagedUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        
        if (firstName) {
           url = url +  `&firstName=${firstName}`;
        }

        if (lastName) {
            url = url +  `&lastName=${lastName}`;
         }

         if (email) {
            url = url +  `&email=${email}`;
         }

         if (userType) {
            url = url +  `&userType=${userType}`;
         }
    
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());
    
        return this.httpClient.get<{result: {Result: number, Data: string}}>(url, { headers: headers });
    }

    public getAccessibleAssessmentData(id: string): Observable<any>
    {
        let url = `${this.url}GetAccessibleAssessmentData?id=${id}`;

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.get<{ result: { Result: number, Data: string } }>(url, { headers: headers });
    }

    public getDuplicateUsers(): Observable<{ result: { Result: number, Data: string } }> {
                let url = `${this.url}GetDuplicateUsers`;
/*        let url = 'http://localhost:54541/AdminService.svc/GetDuplicateUsers';*/

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get<{ result: { Result: number, Data: string } }>(url, { headers: headers });
    }

    public postAssessmentsModISync(encriptedData: string): Observable<any> {
        let url = `${this.url}P79`;

        let body: any = {
            'xk8': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postCreateAssessmentMod1Group body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminService.svc/MS49?hg={2020-04-21T00:00:00}
    public getAssessmentsModlStudents(dateValue: string): Observable<any> {
        let url = `${this.url}MS49?hg=${dateValue}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //AdminService.svc/QA57
    public postAddNewAssessmentModlStudent(encryptedData: string): Observable<any> {
        let url = `${this.url}ZL02`;

        let body: any = {
            "xv3": encryptedData
        }

        body = JSON.stringify(body);
        console.log('postAddNewAssessmentModlStudent body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminServices.svc/MW34
    public postEnableResultsModl(dateValue: string): Observable<any> {
        let url = `${this.url}MW32`;

        let body: any = {
            'jb3': dateValue
        }

        body = JSON.stringify(body);
        console.log('postEnableResultsModl body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //AdminServices.svc/KN7
    public postDownloadReportAssessmentModl(dateValue: string, dateText: string): Observable<any> {
        let url = `${this.url}X96`;

        let body: any = {
            "zz2": this._Globals.getUserId(),
            "jh2": dateValue,
            "ds": dateText
        }

        body = JSON.stringify(body);
        console.log('postDownloadReportAssessmentModl body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

}

export class AdminPurchaseDto {
    ab2: AdminAssessmentPurchaseDto;
}

export class AdminAssessmentPurchaseDto {
    LU0: number;
    LU7: number;
    LU5: number;
    LU4: string;
    LU3: AssessmentPurchaseDetails[];
}

export class AssessmentPurchaseDto {
    CoachId: number;
    TotalAmount: number;
    AssignedId: number;
    EncriptedCardId: string;
    Details: AssessmentPurchaseDetails[];
}

export class AssessmentPurchaseDetails {
    X2: number; //AssessmentId
    X5: number; //Amount
    X9: number; //Total
}

interface IInput {
    ChoiceId: number;
    SectionId: number;
    FromIndex: number;
    ToIndex: number;
}

export class SectionChoice {
    ChoiceId: number;
    SectionId: number;
    Text: string;
    Order: number;
    PositivePoints: number;
    NegativePoints: number;
    Localizations: any[];
}

export class RaterTypeDto {
    Id: number;
    Name: string;
    Min: number;
    IsGlobal: boolean;
    Owner: number;
}

export class QuestionDto {
    Id: number;
    Type: number;
    Levels: number;
    NegativelyKeyed: number;
    IsTestQuestion: number;
    Localizations: LocalizationsDto[];
    Choices: any[];
    IsMandatory: boolean;
    Category: number;
}

export class ChoiceSetDto {
    ChoiceSetId: number;
    Name: string;
    Choices: ChoicesDto[];
    SectionType: number;
}

export class ChoicesDto {
    Id: number;
    Text: string;
    PositivePoints: number;
    NegativePoints: number;
    SectionId: number;
    Order: number;
    Status: number;
    Localizations: LocalizationsDto[];

    tempId: number;
}

export class LocalizationsDto {
    LanguageShortCode: string;
    Text: string;
}

interface ISections {
    Id: number;
    Order: number;
    Type: number;
    Questions: IQuestions[];
}

interface IQuestions {
    Id: number;
    Order: number;
    IsTestQuestion: number;
    Status: number;
}

export class SaveAssessmentsDto {
    id: any;
    name: string;
    niche: string;
    price: number;
    majorVersion: string;
    minorVersion: string;
    sections: ISections[];
    reportTemplates: any[];
    emailTemplates: any[];
    is360: boolean;
}